import {FilterHeader} from "@FRAMEWORK/ui/desktop/filter";
import {Flex, LineHeader} from "@FRAMEWORK/ui/desktop/layout";
import {Ellipsis} from "@FRAMEWORK/ui/desktop/text";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import styled from "styled-components";

const FilterTagContainer = styled.div`
	display: flex;
	align-items: center;

	li {
		display: inline;
	}
`;

const FilterTitle = styled.span`
	display: inline-flex;
	margin-right: 20px;
	gap: 9px;
	align-items: center;

	&:before {
		display: inline-block;
		width: 15px;
		height: 15px;
		background: url(${SpriteImage}) -222px 0 / 400px 400px;
		content: "";
	}
`;

const Count = styled.strong`
	margin-left: 6px;
	font-family: "PT-medium";
	font-weight: normal;
	color: var(--blue-color);
`;

const ResetButton = styled.button`
	background-color: transparent;
	font-size: var(--basic-size);
	color: var(--gray-color);
`;

const ContentWrap = styled.div`
	margin-bottom: 40px;
`;

const ContentHeader = styled(LineHeader)`
	position: sticky;
	top: 0;
	background-color: #fff;
	z-index: 3;

	p {
		display: flex;
		margin-left: 20px;
		font-size: var(--medium-size);
		align-items: center;
		line-height: 1;

		&:before {
			display: inline-block;
			width: 1px;
			height: 12px;
			margin-right: 20px;
			background-color: var(--line-color);
			content: "";
		}
	}
`;

const FilterHeaderWrap = styled(FilterHeader)`
	position: sticky;
	top: 72px;
	margin-top: -10px;
	z-index: 5;
`;

const Content = styled.div`
	display: flex;
	gap: 50px;
`;

const ProcutContentWrap = styled.div`
	position: relative;
	width: 100%;
`;

const ProcutList = styled.ul`
	display: flex;
	flex-direction: column;
`;

const ProcutListItem = styled.li`
	position: relative;
	display: flex;
	padding: 30px 0;
	border-top: 1px solid var(--line-color);
`;

const ProductListItemData = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	cursor: pointer;
`;

const ProcutItemLink = styled.div`
	display: grid;
	width: 100%;
	gap: 40px;
	grid-template-columns: 275px 1fr;
	// grid-template-rows: 160px;
	cursor: pointer;
`;

const TagGroup = styled.div`
	margin-bottom: 15px;
`;

const Name = styled.h5`
	margin-top: 10px;
	font-size: 16px;
	font-family: "PT-medium";
	color: var(--emp-color);
`;

const InfoGroup = styled(Flex)`
	position: relative;
	display: block;
	padding: 12px 50px 16px 20px;
	margin: 12px 0 10px;
	border-radius: 10px;
	background: var(--disabled-color);
	font-size: var(--basic-size);
	color: var(--default-color);
	line-height: 24px;

	em {
		display: block;
		color: var(--blue-color);
	}
`;

const InfoGroupContent = styled.div<{show?: boolean}>`
	overflow: hidden;
	max-height: 72px;

	${props =>
		props.show &&
		`
			max-height: none;
		`}
`;

const Grade = styled.em`
	margin-left: 11px;
	color: var(--emp-color);
`;

const Price = styled.span`
	display: flex;
	align-items: baseline;
	font-size: var(--basic-size);
	color: var(--red-color);

	strong {
		margin-right: 2px;
		font-size: 20px;
	}
`;

const Checkboxbox = styled.div`
	position: absolute;
	top: 10px;
	left: 10px;
	z-index: 2;
`;

const PromotionBox = styled.div`
	position: absolute;
	top: 10px;
	right: 10px;
	z-index: 2;
	display: flex;
	gap: 4px;
`;

const GridListWrap = styled.div`
	margin-bottom: 20px;
`;

const FilterTagBox = styled.ul`
	position: relative;
	display: inline-flex;
	max-width: 1060px;
	gap: 6px;
	overflow-x: auto;
	overflow-y: hidden;
	white-space: nowrap;

	li {
		display: inline-flex;
		height: 30px;
		padding: 0 10px;
		border-radius: 3px;
		background-color: #f3f3f3;
		font-size: var(--basic-size);
		align-items: center;
	}

	&::-webkit-scrollbar {
		display: none;
	}
`;

const Review = styled.span`
	display: flex;
	align-items: center;
	white-space: nowrap;
`;

const TagSquareWrap = styled(Flex)`
	width: 390px;
	flex-wrap: wrap;
`;

const BenefitButton = styled.button`
	position: absolute;
	bottom: 15px;
	right: 15px;
	width: 28px;
	height: 28px;
	border: 1px solid var(--bl-color);
	background: #fff;
	cursor: pointer;
	z-index: 1;

	&:before,
	&:after {
		position: absolute;
		top: 50%;
		left: 50%;
		display: block;
		background-color: var(--emp-color);
		transform: translate(-50%, -50%);
		content: "";
	}
	:after {
		width: 10px;
		height: 2px;
	}

	:before {
		width: 2px;
		height: 10px;
	}
`;

const Summary = styled.div`
	display: flex;
	padding-top: 10px;
	flex-direction: column;
	gap: 10px;

	dl {
		display: flex;
		font-size: var(--basic-size);
		gap: 10px;
		align-items: center;
	}

	dt {
		padding-right: 10px;
		color: var(--emp-color);
		flex-shrink: 0;
	}

	dd {
		display: flex;
		color: var(--default-color);
		align-items: end;
	}
`;

const SummaryDays = styled.dl`
	&:before {
		display: inline-block;
		width: 1px;
		height: 13px;
		margin: 0 6px;
		background: #ddd;
		content: "";
	}
`;

const PriceTag = styled.div`
	display: flex;
	gap: 4px;
	margin-right: 10px;
`;

const PriceBox = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: 12px;
`;

const PromotionFlag = styled.em`
	display: inline-flex;
	align-items: center;
	height: 24px;
	padding: 0 8px;
	border: 1px solid #3964f0;
	border-radius: 4px;
	background-color: #ebeffa;
	font-size: 14px;
	font-family: "PT-regular";
	box-sizing: border-box;
	line-height: 1;
	color: #3964f0;
`;

const YellowpangdealTag = styled.span`
	position: relative;
	display: flex;
	height: 22px;
	padding-right: 10px;
	margin-right: 10px;

	span {
		display: flex;
		padding: 0 4px 0 10px;
		background-color: #ffde2f;
		font-size: var(--small-size);
		color: #ff1e00;
		line-height: 1;
		align-items: center;
	}

	&:after {
		position: absolute;
		top: 0;
		right: 0;
		width: 0;
		height: 0;
		border-bottom: 10px solid transparent;
		border-top: 12px solid transparent;
		border-left: 10px solid #ffde2f;
		border-right: 0px solid transparent;
		content: "";
	}
`;

const YellowLiveFlag = styled.span`
	position: relative;
	display: flex;
	align-items: center;
	height: 24px;
	padding: 0 10px;
	margin-right: 10px;
	border-radius: 12px;
	background-color: #ff5858;

	span {
		line-height: 1;
		color: #fff;
		font-size: var(--small-size);
	}
`;

const RegularPrice = styled.span`
	margin-right: 17px;
	font-size: 16px;
	color: var(--emp-color);
	text-decoration: line-through;
	line-height: 1;
`;

const DiscountPrice = styled.em`
	font-size: var(--basic-size);
	color: var(--red-color);
	line-height: 1;

	strong {
		font-family: "PT-medium";
		font-weight: normal;
		font-size: 20px;
	}
`;

const CouponBox = styled.div`
	display: flex;
	padding: 0 2px;
	margin-right: 15px;
	font-size: var(--basic-size);
	color: var(--emp-color);
	line-height: 1;
	align-items: center;
	gap: 10px;
`;

const CouponIcon = styled.span`
	display: flex;
	align-items: center;

	i {
		display: flex;
		height: 18px;
		padding: 0 4px;
		font-size: 10px;
		color: var(--emp-color);
		font-style: normal;
		border-top: 1px solid #d6d6d6;
		border-bottom: 1px solid #d6d6d6;
		align-items: center;
	}

	&:before {
		display: block;
		width: 3px;
		height: 20px;
		background: url(${SpriteImage}) -62px 0 / 400px 400px;
		content: "";
	}

	&:after {
		display: block;
		width: 7px;
		height: 20px;
		background: url(${SpriteImage}) -66px 0 / 400px 400px;
		content: "";
	}
`;

const Hashtag = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 33px;
	padding: 0 10px;
	background: rgba(0, 0, 0, 0.5);
	font-size: var(--basic-size);
	color: #fff;
	text-align: left;
	line-height: 33px;
	box-sizing: border-box;
	overflow: hidden;
`;

const ImageBox = styled.div`
	position: relative;
	height: 185px;

	img {
		width: 100%;
	}
`;

const BannerImg = styled.div`
	margin: 40px 0;

	a {
		display: block;
	}

	img {
		width: 240px;
		height: auto;
		vertical-align: top;
	}
`;

const FilterTagDeleteButton = styled.button`
	display: block;
	position: relative;
	width: 12px;
	height: 12px;
	margin-left: 5px;
	margin-top: 1px;
	background-color: transparent;
	font-size: 0;

	&::before,
	&::after {
		position: absolute;
		top: 50%;
		left: 0;
		right: 0;
		height: 1px;
		background: #7c7c7c;
		transform: translateY(-50%);
		content: "";
	}

	&::before {
		transform: rotate(45deg);
	}

	&::after {
		transform: rotate(-45deg);
	}
`;

const AreaGridList = styled.ul`
	display: grid;
	padding: 30px;
	margin: 30px 0 20px;
	border: 1px solid var(--line-color);
	grid-template-columns: repeat(4, 1fr);
	gap: 15px 20px;

	li {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	input {
		flex-shrink: 0;
	}

	label {
		display: flex;
		align-items: center;
		justify-content: center;

		${Ellipsis(1)}
	}
`;

const FilterCalendarWrap = styled.div`
	margin-bottom: 20px;
	input {
		height: 37px;

		&:focus {
			border-color: var(--line-color);
			outline: none;
			cursor: pointer;
		}
	}

	i {
		right: 0;
	}
`;

const FilterOptionList = styled.ul`
	display: flex;
	max-height: 154px;
	margin-bottom: 20px;
	flex-wrap: wrap;
	gap: 6px 6px;
	overflow-y: auto;

	li {
		label,
		span {
			display: flex;
			padding: 6px 10px;
			border: 1px solid var(--line-color);
			border-radius: 3px;
			box-sizing: border-box;
			font-size: var(--basic-size);
			align-items: center;
		}

		span {
			color: var(--bl-color);
		}

		input[type="checkbox"] {
			position: absolute;
			width: 1px;
			height: 1px;
			padding: 0;
			margin: -1px;
			overflow: hidden;
			clip: rect(0, 0, 0, 0);
			border: 0;

			&:checked + label {
				border-color: var(--emp-color);
				color: var(--emp-color);
			}
		}
	}
`;

const ImageItem = styled.img`
	width: 275px;
	height: 185px;

	.img-error {
		width: 100%;
		height: 100%;
	}
`;

export {
	FilterTagContainer,
	FilterTitle,
	Count,
	ResetButton,
	ContentWrap,
	ContentHeader,
	Content,
	ProcutContentWrap,
	ProcutList,
	ProcutListItem,
	ProductListItemData,
	ProcutItemLink,
	TagGroup,
	Name,
	InfoGroup,
	InfoGroupContent,
	Grade,
	Price,
	Checkboxbox,
	GridListWrap,
	FilterTagBox,
	Review,
	TagSquareWrap,
	BenefitButton,
	Summary,
	SummaryDays,
	PromotionFlag,
	YellowpangdealTag,
	YellowLiveFlag,
	PriceTag,
	PromotionBox,
	RegularPrice,
	DiscountPrice,
	CouponBox,
	CouponIcon,
	PriceBox,
	Hashtag,
	ImageBox,
	FilterHeaderWrap,
	BannerImg,
	FilterTagDeleteButton,
	AreaGridList,
	FilterCalendarWrap,
	FilterOptionList,
	ImageItem,
};
